import "core-js/modules/es7.string.pad-end";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.number.constructor";
import _typeof from "/tmp/project/zhsh/ysa-IntegratedServiceSaas_webTMP/home/node_modules/@babel/runtime-corejs2/helpers/esm/typeof.js";
import "core-js/modules/es7.string.pad-end";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.number.constructor";
export default {
  install: function install(Vue) {
    // 金额转换
    Vue.prototype.amountConver = function (val) {
      if (val === null || val === '' || val === undefined) return '/';
      if (Number(val) === 0) return 0;
      return (Number(val) / 100).toFixed(2);
    };
    // 元转分
    Vue.prototype.yuanToCent = function (val) {
      var cent = '';
      if (/^[1-9]\d*(,\d{3})*(\.\d{1,2})?$|^0\.\d{1,2}$/.test(val)) {
        // 判断是否为金额
        var numberNum = Number(val);
        var centStr = numberNum.toString();
        var centArr = centStr.split('.');
        if (centArr.length > 1) {
          cent = Number(centArr[0]) * 100 + Number(centArr[1].padEnd(2, '0'));
        } else {
          cent = numberNum * 100;
        }
      } else if (val === 0 || val === '0') {
        cent = 0;
      }
      return cent;
    };
    // 分转元
    Vue.prototype.centToYuan = function (val) {
      var yuan = '';
      if (/^[1-9]\d*(,\d{3})*(\.\d{1,2})?$|^0\.\d{1,2}$/.test(val)) {
        // 判断是否为金额
        var numberNum = Number(val);
        var centStr = numberNum.toString();
        var centArr = centStr.split('.');
        if (centArr.length > 1) {
          var newNumber = Number(centArr[0] + centArr[1]);
          var centArr2L = centArr[1].length;
          var multiple = 100 * Number.Math.pow(10, centArr2L);
          yuan = newNumber / multiple;
        } else {
          yuan = numberNum / 100;
        }
      } else if (val === 0 || val === '0') {
        yuan = 0;
      }
      return yuan;
    };
    // 截取文件url格式
    Vue.prototype.urlFormat = function (url) {
      if (url == null || url === '') return '';
      var file = url.split('.');
      return file[file.length - 1];
    };

    // 获取导出当前日期
    Vue.prototype.exportData = function () {
      var date = new Date();
      var Y = date.getFullYear();
      var M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1;
      var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      var H = date.getHours() < 10 ? '0' + date.getHours() : date.getHours();
      var m = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes();
      var s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      return "".concat(Y).concat(M).concat(D).concat(H).concat(m).concat(s);
    };

    // 判断是否JSON格式
    Vue.prototype.isJSON = function (str) {
      if (typeof str !== 'string') return false;
      try {
        var obj = JSON.parse(str);
        if (_typeof(obj) === 'object' && obj) {
          return true;
        } else {
          return false;
        }
      } catch (e) {
        return false;
      }
    };
  }
};